import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { MenuItem, MenuText } from './common/Themes'

import ConfigGeneral from './common/ConfigGeneral'
import ConfigActivite from './common/ConfigActivite'
import { setTopbar, setIpAddress } from '../redux/actions'

import { ToastContainer, toast } from 'react-toastify'

const internalIp = require('internal-ip')

const Configurations = () => {

    useEffect(() => {
        (async () => {
            window.scrollTo(0, 0)
            const ipv4 = await internalIp.v4()
            dispatch(setIpAddress(ipv4))
        })();
    }, [])

    const dispatch = useDispatch()
    const { activites } = useSelector(state => state.fetch)
    const { topbar } = useSelector(state => state.config)
    const [confActivites, setConfActivites] = useState([])

    useEffect(() => {
        setConfActivites(activites.filter(({ menu }) => !!menu))
    }, [activites])

    useEffect(() => {
        dispatch(setTopbar(confActivites[0]?.aid))
    }, [confActivites])


    const hexToRgb = hex =>
        hex
            .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b)
            .substring(1).match(/.{2}/g)
            .map(x => parseInt(x, 16))


    const menuItem = (aid, name, color1, color2) => {
        const length = 5
        const status = topbar === aid
        return (
            <MenuItem onClick={() => { dispatch(setTopbar(aid)); window.scrollTo(0, 0); }} key={aid} length={length} rgb={status ? hexToRgb(color2) : ''}>
                <img src={`/uploads/activites/logo/${aid}.svg`} className='configurations__icon' />
                <MenuText color={color1} fontSize={name.length > 12 ? '1.5rem' : '1.8rem'}>{name}</MenuText>
            </MenuItem>
        );
    }


    const Toasky = ({ body }) => {
        return (
            <div className="toasky">
                <div className="toasky__title">Attention :</div>
                <div className="toasky__body">{body}</div>
            </div>
        );
    }


    return (
        <div className="configurations">

            <ConfigGeneral toast={toast} Toasky={Toasky} />
            
            <ConfigActivite toast={toast} Toasky={Toasky} />

            <div className="configurations__topbarWrapper">
                {confActivites?.slice(0,5)?.map(({ aid, name, color1, color2 }) => menuItem(aid, name, color1, color1))}
            </div>

            <ToastContainer className='toasky__wrapper' position="bottom-right" autoClose={3500} />

        </div>
    );
}

export default Configurations